import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
// components
import { PageNotFoundPageContent } from "@components/PageNotFound/PageNotFound"

const PageNotFoundPage = () => {
    return (
        <NavigationsPage>
            <PageWrapper>
                <PageNotFoundPageContent />
            </PageWrapper>
        </NavigationsPage>
    )
}

export default PageNotFoundPage
